import type { Directive } from "vue"
import sanitizeHtml from "sanitize-html"

const options = {
  allowedTags: [
    "b",
    "strong",
    "i",
    "div"
  ],
}

export function cleanHtml(html: string) {
  return sanitizeHtml(html, options)
}

export const SanitizeHtml: Directive = {
  beforeMount(el, binding) {
    el.innerHTML = cleanHtml(binding.value)
  },
  updated(el, binding) {
    el.innerHTML = cleanHtml(binding.value)
  },
}
